import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Card, Empty } from 'antd';

import Spin from 'components/Spin';
import type { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

import ListItemNotification from './ListItemNotification';

const ListNotification = () => {
  const { type } = useParams<{ type: ENotificationType }>();
  const [notifications] = useObservable(() => notificationService.getListNotifications(type), [type]);
  const [isLoadingNotifications] = useObservable(() => notificationService.isLoadingNotifications(), []);

  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const readAll = qs.get('readAll');

    if (readAll === 'true') {
      return notificationService.readAllNotifications();
    }

    notificationService.readNotificationByType(type);
  }, [type]);

  if (isLoadingNotifications) {
    return <Spin />;
  }

  if (!notifications?.length) {
    return (
      <Card>
        <Empty description='Não há notificações' />
      </Card>
    );
  }

  return (
    <Card className='overflow-hidden'>
      {(notifications || []).map((n, index) => (
        <ListItemNotification key={index} notification={n} />
      ))}
    </Card>
  );
};

export default ListNotification;
